import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { TranslateService } from "@ngx-translate/core";
import { AppLoadingIndicatorService } from "../../../../../../services/app-loading-indicator.service";

/**
 * Exports a Valuation Event to Argus
 */
export class ExportPortfolioToArgusGridActionHandler extends GridActionHandlerBase {
  /**
   * TranslateService
   */
  private translate: TranslateService;

  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param appLoadingIndicator AppLoadingIndicatorService
   */
  constructor(injector: Injector,
    workspace: WorkspaceBase,
    private appLoadingIndicator: AppLoadingIndicatorService) {
    super(injector, workspace, 'exportToArgus');
    this.translate = this.injector.get(TranslateService);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const allValuationEvents = this.workspace.grid.getFlattenGridDataResultData();
    const checkedValuationEvents = [];

    if (allValuationEvents) {
      allValuationEvents.forEach(valuationEvent => {
        if (valuationEvent.checkbox) {
          checkedValuationEvents.push(valuationEvent);
        }
      });
      if (checkedValuationEvents.length == 0) {
        checkedValuationEvents.push(this.workspace.grid.selectedItem);
      }
    }

    if (!checkedValuationEvents.length) {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChoosePortfolio');
      return;
    }

    this.eventBus.broadcastEvent("argusDialog", {
      success: () => {
        this.appLoadingIndicator.show();
        this.eventBus.broadcastEvent("exportToArgusPortfolio", checkedValuationEvents);
      },
      cancel: () => {
        // Nothing
      },
      dialogContent: () => { return this.translate.instant('exportToArgusConfirmDialog.message') },
      shouldShowCloseButton: () => {
        return false;
      }
    }, 'exportToArgusConfirmDialog');
  }
}
